{
  "name": "deeplink-app",
  "version": "develop-2.60.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --open",
    "build:ci": "ng build",
    "build:dev": "ng build --configuration development",
    "build:hml": "ng build --configuration stage",
    "build:pro": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "npm run test:prod",
    "test:watch:coverage": "ng test --source-map=true --code-coverage=true",
    "test:prod": "ng test --watch=false --browsers ChromeHeadlessNoSandbox --code-coverage",
    "lint": "ng lint",
    "lint:staged": "pretty-quick --staged",
    "lint:prod": "ng lint --fix",
    "serve:build": "angular-http-server --open --path dist/app/browser",
    "prepare": "husky install",
    "e2e": "ng e2e",
    "e2e:headless": "ng e2e --headless --watch false",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "engines": {
    "node": "^22",
    "npm": "^10"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^21.2.21",
    "@angular/animations": "^21.2.21",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.21",
    "@angular/compiler": "^21.2.21",
    "@angular/core": "^21.2.21",
    "@angular/forms": "^21.2.21",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.21",
    "@angular/platform-browser-dynamic": "^21.2.21",
    "@angular/router": "^21.2.21",
    "@bugsnag/browser-performance": "^3.2.0",
    "@bugsnag/js": "^8.2.0",
    "@bugsnag/plugin-angular": "^8.2.0",
    "@clmeida/vss-app-modal": "^1.5.0",
    "@faker-js/faker": "^10.5.0",
    "@nerpatricia/angular-cc-library": "^3.7.1",
    "@sentry/angular": "^10.38.0",
    "@types/node-forge": "^1.3.14",
    "ng-otp-input": "^2.0.8",
    "ngx-mask": "^21.0.1",
    "node-forge": "^1.4.0",
    "normalize.css": "^8.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.7.0",
    "url-join": "^5.0.0",
    "uuid": "^13.0.0",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.1.2",
    "@angular-eslint/builder": "~21.2.0",
    "@angular-eslint/eslint-plugin": "~21.2.0",
    "@angular-eslint/eslint-plugin-template": "~21.2.0",
    "@angular-eslint/schematics": "^21.2.0",
    "@angular-eslint/template-parser": "~21.2.0",
    "@angular/build": "^21.1.2",
    "@angular/cli": "~21.1.2",
    "@angular/compiler-cli": "^21.1.2",
    "@cypress/schematic": "^5.0.0",
    "@faker-js/faker": "^10.5.0",
    "@types/jasmine": "^6.0.0",
    "@types/url-join": "^4.0.3",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "angular-http-server": "^1.12.0",
    "cypress": "^15.9.0",
    "eslint": "^8.57.1",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-prettier": "^5.2.3",
    "husky": "^9.1.7",
    "jasmine-core": "^6.0.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "prettier": "^3.4.2",
    "pretty-quick": "^4.0.0",
    "typescript": "^5.9.3"
  },
  "overrides": {
    "ajv": "^8.18.0",
    "babel-traverse": "^7.28.0",
    "eslint": {
      "@eslint/eslintrc": {
        "ajv": "^8.18.0"
      }
    },
    "json5": "^2.2.3",
    "minimist": "^1.2.8",
    "tsconfig-paths": {
      "json5": "^2.2.3",
      "minimist": "^1.2.8"
    },
    "picomatch": "^4.0.4"
  }
}
